/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit SendPatientMessage/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import CancelAction from './CancelAction/index'
import CloseAction from './CloseAction/index'
import ModalFullScreen from 'DesignSystem/ModalFullScreen/index'
import React from 'react'
import Recipients from './Recipients/index'
import SendEmailAction from './SendEmailAction/index'
import SendSecureMessageAction from './SendSecureMessageAction/index'
import TysiaIconSms from 'DesignSystem/Svgs/TysiaIconSms/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function SendPatientMessage({
  children,
  patientId,
  personId,
  fileId,
  fileType,
  message,
  tags,
  viewPath = "/DesignSystem/SendPatientMessage",
  onClose
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
let dtColorsBlue800 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.blue.800'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtColorsNeutral900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.900'
        })
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
  return (<React.Fragment
>
<ModalFullScreen
  viewPath={`${viewPath}/ModalFullScreen`}
 size="medium"
 paddingTop={0}
 paddingRight={0}
 paddingBottom={0}
 paddingLeft={0}
 dangerouslyBypassFocusLock={true}
>
{childProps => (
<React.Fragment>
<div
  data-testid="SendPatientMessage.Horizontal"
  data-view-path={viewPath}
 style={{'--pt-1-ZH0sU7': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pb-2-ZH0sU7': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pr-3-ZH0sU7': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM,'--pl-4-ZH0sU7': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM,'--btlr-5-ZH0sU7': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--btrr-6-ZH0sU7': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bbc-7-ZH0sU7': dtColorsNeutral200}}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="SendPatientMessage.Horizontal:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal1}`}
>
<TysiaIconSms
  viewPath={`${viewPath}/TysiaIconSms`}
 height={18}
 width={18}
 fill2={dtColorsBlue800}
 marginRight={dtSpaceXxs}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="large"
 weight="medium"
 color={dtColorsNeutral900}
 text="Send message"
/>
</div>
<CloseAction
  viewPath={`${viewPath}/CloseAction`}
 onClick={onClose}
/>
</div>
<div
  data-testid="SendPatientMessage.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="SendPatientMessage.Vertical:1"
  data-view-path={viewPath}
 style={{'--pt-1-ZH0sU7': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM,'--pb-2-ZH0sU7': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM,'--pr-3-ZH0sU7': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM,'--pl-4-ZH0sU7': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM}}
 className={`views-block ${styles.Vertical1}`}
>
<Recipients
  viewPath={`${viewPath}/Recipients`}
/>
</div>
</div>
<div
  data-testid="SendPatientMessage.Horizontal:2"
  data-view-path={viewPath}
 style={{'--pt-1-ZH0sU7': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pb-2-ZH0sU7': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pr-3-ZH0sU7': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM,'--pl-4-ZH0sU7': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM,'--bc-8-ZH0sU7': dtColorsWhite,'--btc-9-ZH0sU7': dtColorsNeutral200,'--bblr-10-ZH0sU7': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bbrr-11-ZH0sU7': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal2}`}
>
<CancelAction
  viewPath={`${viewPath}/CancelAction`}
 onClick={onClose}
/>
<SendEmailAction
  viewPath={`${viewPath}/SendEmailAction`}
/>
<SendSecureMessageAction
  viewPath={`${viewPath}/SendSecureMessageAction`}
/>
</div>
</React.Fragment>
)}
</ModalFullScreen>
{children}
</React.Fragment>)
}